var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69986 5.71484C3.80896 5.71484 3.36279 6.79199 3.99275 7.42195L7.29282 10.722C7.68335 11.1125 8.31651 11.1125 8.70704 10.722L12.0071 7.42195C12.6371 6.79199 12.1909 5.71484 11.3 5.71484H4.69986Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistDownArrow);
export default __webpack_public_path__ + "static/media/distDownArrow.4550a51c65d44b78944fe5b3ec9ad421.svg";
export { ForwardRef as ReactComponent };